import styled from 'styled-components'
import { textMuted, white } from '@/theme/colors'
import { shadows, radii } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'

export const ChartCard = styled.div`
	background-color: ${white};
	border-radius: ${radii.inner};
	padding: 24px;
	box-shadow: ${shadows.inner};
	margin-top: 24px;
`

export const ChartTitle = styled.h2`
	margin: 0 0 16px;
	${text.title}
	color: ${textMuted};
`

export const Legend = styled.div`
	display: flex;
	gap: 20px;
	margin-bottom: 12px;
	flex-wrap: wrap;
`

export const LegendItem = styled.span`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: ${fontSizes.small};
	color: ${textMuted};
`

export const Swatch = styled.span<{ $color: string }>`
	width: 12px;
	height: 12px;
	border-radius: ${radii.tiny};
	background-color: ${({ $color }) => $color};
`

export const Chart = styled.svg`
	width: 100%;
	height: auto;
	display: block;
`

